import { Grid2 } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import CommonButton from "../../../../../component/Button";
import CommonAccordion from "../../../../../modules/common-components/CommonAccordion";
import { CommonGrid2 } from "../../../../../modules/common-components/StyledComponents";
import MixedComponent from "../mixed-component";
import General from "./component/General";

const AddUser = ({
  userManagement,
  isLoading,
  storageData,
  expandedPanel,
  buttonLoading,
  userData,
  primaryViewData,
  DemoConfigData,
  validationSchema,
  handleSubmit,
  handleChangeAccor,
  handleScrollToErrorCheck,
  handleCancel,
}) => {
  return (
    <Grid2 size={12}>
      <Formik
        enableReinitialize={true}
        initialValues={userData}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmit(values);
        }}
      >
        {({ validateForm }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <Grid2 container spacing={2} marginBottom={"2rem"}>
                <CommonGrid2
                  item
                  size={12}
                  gap="10px"
                  display="flex"
                  justifyContent={"end"}
                >
                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    border="#D0D5DD"
                    fontWeight="600"
                    value="Cancel"
                    padding="8px 20px"
                    disabled={buttonLoading.disabled}
                    loading={buttonLoading.cancelLoading}
                    onClick={handleCancel}
                  />
                  {!userManagement.view_mode && (
                    <CommonButton
                      variant="contained"
                      color="white"
                      background="#7F56D9"
                      fontWeight="600"
                      value={userManagement.id ? "Update" : "Add"}
                      padding="8px 20px"
                      type="submit"
                      disabled={buttonLoading.disabled}
                      loading={buttonLoading.addLoading}
                      onClick={() => {
                        setTimeout(async () => {
                          let data = await validateForm();
                          handleScrollToErrorCheck(data);
                        }, 0);
                      }}
                    />
                  )}
                </CommonGrid2>
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"General"}
                  children={
                    <General
                      loading={isLoading}
                      getShow={userManagement.view_mode}
                    />
                  }
                  defaultOpen
                  open={expandedPanel.includes("General")}
                  onChange={handleChangeAccor("General")}
                />
              </Grid2>
              <Grid2 size={12} paddingTop={3}>
                <CommonAccordion
                  title={"Information"}
                  defaultOpen
                  open={expandedPanel.includes("Information")}
                  onChange={handleChangeAccor("Information")}
                  children={
                    <MixedComponent
                      editData={primaryViewData}
                      rowSize
                      loading={isLoading}
                    />
                  }
                />
              </Grid2>
              {storageData?.organization === "Demo" &&
                storageData?.role === "Admin" && (
                  <Grid2 size={12} paddingTop={3}>
                    <CommonAccordion
                      title={"Demo Config"}
                      defaultOpen
                      open={expandedPanel.includes("Demo Config")}
                      onChange={handleChangeAccor("Demo Config")}
                      children={
                        <MixedComponent
                          editData={DemoConfigData}
                          rowSize
                          loading={isLoading}
                        />
                      }
                    />
                  </Grid2>
                )}
            </Form>
          );
        }}
      </Formik>
    </Grid2>
  );
};

export default AddUser;
